<template>
      <div class="p-grid p-nogutter" style="min-height: 75px;">
        <div class="p-col">

          <h2>

            <!-- WEB -->
            <span v-if="(serialNumber == null)">
              <a @click="$router.push({ name: 'library' })" style="cursor: pointer">{{$t('library.title_web')}}</a>
              
              <span v-if="recipeId">
                <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
                <a @click="$router.push({ name: 'recipe-overview', params: { recipeId: recipeId } })" style="cursor: pointer">{{recipeName}}</a>
              </span>

            </span>

            <!-- APPLIANCE -->
            <span v-else>
              <a @click="$router.push({ name: 'appliance-details', params: { serialNumber: serialNumber } })" style="cursor: pointer">{{applianceName}}</a>
              <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
              <a @click="$router.push({ name: 'appliance-library', params: { serialNumber: serialNumber } })" style="cursor: pointer">{{$t('library.title_device')}}</a>
              <span v-if="recipeId">
                <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
                <a @click="$router.push({ name: 'appliance-recipe-overview', params: { serialNumber: serialNumber, recipeId: recipeId } })" style="cursor: pointer">{{recipeName}}</a>
              </span>
            </span>

            <!-- STEP 1 - FASI -->
            <span v-if="(step==1)">
              <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
              <span v-if="recipeId == null">
                {{$t('library.cycle.new_cycle_title')}}
              </span>
              <span v-else>
                {{$t('library.cycle.edit_cycle_title')}}
              </span>
            </span>
            <span v-else>
              <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
              <a @click="updateStep(1)" style="cursor: pointer">
                <span v-if="recipeId == null">
                {{$t('library.cycle.new_cycle_title')}}
                </span>
                <span v-else>
                  {{$t('library.cycle.edit_cycle_title')}}
                </span>
              </a>
            </span>

            <!-- STEP 2 - ICONA COLORE -->
            <span v-if="(step==2)">
              <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
              <span>{{$t('library.steps.icon_color.title')}}</span>
            </span>
            <span v-else-if="(step>2)">
              <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
              <a @click="updateStep(2)" style="cursor: pointer">{{$t('library.steps.icon_color.title')}}</a>
            </span>

            <!-- STEP 3 - INFO -->
            <span v-if="(step==3)">
              <img class="p-pl-3 p-pr-3" src="assets/irinox/icons/arrow_breadcrumb.svg" :alt="$t('common.arrow_right')"/>
              <span>{{$t('library.steps.info.title')}}</span>
            </span>
            
          </h2>

        </div>
        <div class="p-col-fixed p-pb-4" style="width: fit-content">
          <Button v-if="(!buttonHidden)" :label="buttonLabel" @click="click"  />
        </div>
      </div>
</template>

<script>
export default {
  emits: ['click:button', 'update:step'],
  components: {
    },
    props: {
      serialNumber: String,
      applianceName: String,
      recipeId: String,
      recipeName: String,
      step: Number,
      buttonHidden: Boolean
    },
    data() {
        return {
        };
    },
    computed: {
      buttonLabel() {
        if(this.step==1) return this.$t('library.steps.phases.next_button');
        if(this.step==2) return this.$t('library.steps.icon_color.next_button');
        if(this.step==3 && !this.recipeId) return this.$t('library.steps.info.save_new_cycle_button');
        if(this.step==3 && this.recipeId) return this.$t('library.steps.info.save_edit_cycle_button');
        return '?';
      }
    },
    created() {
    },
    mounted() {
    },
    methods: {
      click() {
        this.$emit("click:button");
      },
      updateStep(newStep) {
        this.$emit("update:step", newStep);
      }
    }

}
</script>

<style scoped>
</style>